export const GTM_EVENTS = {
  SUBSCRIPTION_INITIATED: 'subscription_initiated',
} as const;
